import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import style from './ui-close-icon.css?inline';
import '../ui-sprite-svg/ui-sprite-svg';

const CName = 'ui-close-icon';

@customElement(CName)
export class UICloseIcon extends LitElement {
  static readonly styles = unsafeCSS(style);

  render() {
    return html`<ui-sprite-svg .iconID=${'close-icon'}></ui-sprite-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UICloseIcon;
  }
}
